module.exports = __webpack_public_path__ + "static/media/prop-9@2x-thumb.b8d23c45.webp";